<template>
  <div class="edit" @click="showModal(); showBox()"><button type="button">編集</button></div>
  <div class="form allScreen" v-if="show">
    <div class="box" v-if="show_box">
      <div class="header">
        <h2>レビュー編集</h2>
        <div class="close" @click="closeModal(); closeBox()"></div>
      </div>
      <div ref="slider" class="contents keen-slider">
        <div class="reserveForms">
          <div class="inputs">
            <h3>店舗名</h3>
            <p>{{ shopName }}</p>
            <h3>評価</h3>
            <review-rating :edit-review="review.review" @input="setReview" :class="{ error: errors.review }"></review-rating>
            <p v-for="error in errors.review" class="formError">
              {{ error }}
            </p>
            <h3>タイトル</h3>
            <input
                type="text"
                v-model="params.title"
                placeholder="タイトルを入力してください（255文字以下）"
                :class="{ error: errors.title }"
            />
            <p v-for="error in errors.title" class="formError">
              {{ error }}
            </p>
            <h3>コメント</h3>
            <textarea
                v-model="params.content"
                cols="30"
                rows="10"
                placeholder="口コミ本文を入力してください（5,000文字以下）"
                :class="{ error: errors.content }"
            ></textarea>
            <p v-for="error in errors.content" class="formError">
              {{ error }}
            </p>
            <h3>写真の追加</h3>
            <p>※ 拡張子はpng, jpeg, gifの対応となります。<br>
              ※ 画像は1MB未満でアップロードをお願いいたします。<br>
              ※ 画像は最大5枚までアップロード可能です。</p>
            <mypage-file-upload :photos="review.photos" @input="setFiles"></mypage-file-upload>
            <p v-for="error in errors.files" class="formError">
              {{ error }}
            </p>
          </div>
          <div class="next">
            <p class="terms">
              <a href="/privacy_policy" target="_blank" rel="noopener">プライバシーポリシー</a>及び<a href="/tos" target="_blank" rel="noopener">利用規約</a>
            </p>
            <div class="button agreeButton" :class="{ disabled: isDisabledButton }" @click.stop="updateReview()">同意して更新する</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    review: Object,
    shopName: String,
    imageUrl: String
  },
  emits: ['updateEvent'],
  data() {
    return {
      show: false,
      show_box: false,
      slide: null,
      index: 0,
      isDisabledButton: false,
      params: {
        id: '',
        review: '',
        title: '',
        content: '',
        images: [],
        files: []
      },
      errors: {},
    };
  },
  mounted() {
    this.setParams()
  },
  methods: {
    showModal() {
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    showBox() {
      this.show_box = true
    },
    closeBox() {
      this.show_box = false
    },
    setParams() {
      this.params.id = this.review.id
      this.params.review = this.review.review
      this.params.title = this.review.title
      this.params.content = this.review.content
    },
    checkValidation() {
      // 必須チェック
      this.errors = {};

      // タイトル
      if (this.params.title.length === 0) {
        this.errors.title = ["タイトルは必ず入力してください"];
      }
      if (this.params.title.length > 255) {
        this.errors.title = ["タイトルは255文字以下で入力してください"];
      }

      // コメント
      if (this.params.content.length === 0) {
        this.errors.content = ["コメントは必ず入力してください"];
      }
      if (this.params.content.length > 5000) {
        this.errors.content = ["コメントは5000文字以下で入力してください"];
      }

      // 評価
      if (this.params.review < 1 || this.params.review > 5) {
        this.errors.review = [];
      }
      if (this.params.review < 1) {
        this.errors.review.push("評価は1〜5で指定してください");
      }
      if (this.params.review > 5) {
        this.errors.review.push("評価は1〜5で指定してください。");
      }

      return Object.keys(this.errors).length === 0;
    },
    setReview(value) {
      this.params.review = value;
    },
    setFiles(files) {
      this.params.images = files.images;
      this.params.files = files.files;
    },
    async updateReview() {
      // 多重submit防止
      this.isDisabledButton = true

      if (this.checkValidation()) {
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        };

        let data = new FormData();
        data.append('id', this.params.id);
        data.append('review', this.params.review);
        data.append('title', this.params.title);
        data.append('content', this.params.content);
        // idのみの配列を作成
        const ids = this.params.images.map(image => image.id);
        data.append('images', ids);
        for (const i in this.params.files) {
          data.append('files['+i+']', this.params.files[i]);
        }
        this.$axios.post('/api/users/review/update', data, config)
            .then((res) => {
              if (res.data.success) {
                this.completeFlag = true
                let self = this
                setTimeout(function() {
                  self.$emit('update-event')
                  self.isDisabledButton = false
                }, 2000)
              } else {
                console.log(res.data.errors)
                this.isDisabledButton = false
                this.errors = res.data.errors
              }
            }).catch(e => {
              this.isDisabledButton = false
              if (!this.$_.isEmpty(e.response.data.errors.review)) {
                this.errors.review = e.response.data.errors.review;
              }
              if (!this.$_.isEmpty(e.response.data.errors.title)) {
                this.errors.title = e.response.data.errors.title;
              }
              if (!this.$_.isEmpty(e.response.data.errors.content)) {
                this.errors.content = e.response.data.errors.content;
              }
              this.errors.files = [];
              if (!this.$_.isEmpty(e.response.data.errors['files.0'])) {
                this.errors.files = e.response.data.errors['files.0'];
              }
              if (!this.$_.isEmpty(e.response.data.errors['files.1'])) {
                this.errors.files = e.response.data.errors['files.1'];
              }
              if (!this.$_.isEmpty(e.response.data.errors['files.2'])) {
                this.errors.files = e.response.data.errors['files.2'];
              }
              if (!this.$_.isEmpty(e.response.data.errors['files.3'])) {
                this.errors.files = e.response.data.errors['files.3'];
              }
              if (!this.$_.isEmpty(e.response.data.errors['files.4'])) {
                this.errors.files = e.response.data.errors['files.4'];
              }
            })
      } else {
        this.isDisabledButton = false
      }
    }
  },
  watch: {
    show(val) {
      if (!val) return
    }
  }
}
</script>

<style lang="scss" scoped>
.form.allScreen {
  .box {
    .contents {
      overflow: scroll;
      padding-bottom: 8rem;

      input.error, textarea.error {
        border: 2px solid #c63200;
        margin-bottom: 2rem !important;
        + p {
          margin-bottom: 2rem !important;
        }
      }

      .formError {
        font-size: 1.2rem !important;
        color: #c63200 !important;
        line-height: 1 !important;
        margin-bottom: 1.6rem !important;
      }

      @media screen and (max-width: 768px) {
        .reserveForms {
          .next {
            padding: 0 1.5rem;
          }
        }
      }
    }
  }
}
</style>
